<template>
  <div class="grid grid-cols-3 gap-4">
    <div>
      <el-select
        v-model="filter"
        @change="handleSearch"
        placeholder="Select"
        class="w-full"
      >
        <el-option key="filter1" label="All Orders" value=""> </el-option>
        <el-option key="filter2" label="Outfitter Checkout" value="internal">
        </el-option>
        <el-option key="filter3" label="WWP Checkout" value="external">
        </el-option>
      </el-select>
    </div>
    <div>
      <base-button-primary class="" @click="handleExport"
        >Export</base-button-primary
      >
    </div>
    <div class="col-span-3 text-sm">
      <vue-good-table
        :columns="columns"
        :rows="orders"
        :search-options="{ enabled: true }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'id', type: 'asc' },
        }"
        :fixed-header="true"
        max-height="800px"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 50,
          position: 'bottom',
          perPageDropdown: [25, 50, 100],
          dropdownAllowAll: false,

          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'hash'">
            {{ props.row.hash ? "Success" : "Fail" }}
          </span>
          <span v-else-if="props.column.field == 'id'">
            <span
              class="cursor-pointer text-blue-600"
              @click="navigateToDetail(props.row)"
            >
              {{ props.row.id }}</span
            >
          </span>
          <span v-else-if="props.column.field == 'isExternal'">
            {{ props.row.isExternal ? "Yes" : "No" }}
          </span>
          <span v-else-if="props.column.field == 'isCounterCheckout'">
            {{ props.row.isCounterCheckout ? "Yes" : "No" }}
          </span>
          <span v-else-if="props.column.field == 'subtotal'">
            ${{ (props.row.subtotal / 100).toFixed(2) }}
          </span>
          <span v-else-if="props.column.field == 'discount'">
            {{ props.row.discount ? props.row.discount.name : "None" }}
          </span>
          <span v-else-if="props.column.field == 'square_transaction'">
            {{
              props.row.square_transaction
                ? props.row.square_transaction.receipt_number
                : "None"
            }}
          </span>
          <span v-else-if="props.column.field == 'discount_value'">
            ${{
              ((props.row.discount_value + props.row.discount24) / 100).toFixed(
                2
              )
            }}
          </span>

          <span v-else-if="props.column.field == 'total'">
            ${{ (props.row.total / 100).toFixed(2) }}
          </span>
          <span v-else-if="props.column.label == 'Details'">
            <base-button-white-small
              class="mr-3"
              @click="showDetail(props.row.id)"
              >View</base-button-white-small
            >
            <base-button-primary-small
              class="mr-3"
              @click="changeEmail(props.row)"
              >Email</base-button-primary-small
            >
            <base-button-primary-small @click="resend(props.row)"
              >Resend</base-button-primary-small
            >
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>

    <change-order-email
      :showModal="showEmailModal"
      :emailData="emailData"
      @saved="handleSavedEmail"
      @close="showEmailModal = false"
    ></change-order-email>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import BaseButtonWhiteSmall from "@/components/ui/buttons/BaseButtonWhiteSmall";
import BaseButtonPrimary from "@/components/ui/buttons/BaseButtonPrimary";
import ChangeOrderEmail from "../../common/ChangeOrderEmail";
export default {
  name: "Closing",
  components: {
    ChangeOrderEmail,
    BaseButtonPrimary,
    BaseButtonWhiteSmall,
    VueGoodTable,
  },

  props: {},
  data() {
    return {
      columns: [
        {
          label: "ID",
          field: "id",
          type: "number",
        },
        {
          label: "Date",
          field: "display_date",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Notes",
          field: "notes",
        },
        {
          label: "Counter",
          field: "isCounterCheckout",
        },
        {
          label: "Square",
          field: "square_transaction",
        },
        {
          label: "Base Price",
          field: "subtotal",
          type: "decimal",
        },
        {
          label: "Coupon",
          field: "discount",
        },
        {
          label: "Discount",
          field: "discount_value",
          type: "decimal",
        },
        {
          label: "Total",
          field: "total",
          type: "decimal",
        },
        {
          label: "Details",
          field: "id",
        },
      ],
      startDate: "",
      endDate: "",
      showEmailModal: false,
      emailData: {
        id: null,
        email: null,
      },
      filter: "",
    };
  },
  methods: {
    navigateToDetail(row) {
      this.$router.push("/dashboard/order-detail/" + row.id);
    },
    handleSavedEmail() {
      this.handleSearch();
      this.emailData = {
        id: null,
        email: null,
      };
      this.showEmailModal = false;
    },
    resend(row) {
      if (confirm("Are you sure you want to re-email this order?")) {
        this.$notify({
          title: "Order",
          message: "Resending...",
          type: "success",
        });
        this.$store.dispatch("order/resend", row.id).then((resp) => {
          if (!resp.success) return;
          this.$notify({
            title: "Order",
            message: "This order has been resent",
            type: "success",
          });
        });
      }
    },
    changeEmail(row) {
      this.emailData.id = row.id;
      this.emailData.email = row.email;
      this.showEmailModal = true;
    },
    handleExport() {
      let url = process.env.VUE_APP_BASE_URL + "/order/export-orders";
      url += "?startDate=" + this.startDate;
      url += "&endDate=" + this.endDate;
      url += "&outfitterId=" + this.$store.getters["auth/outfitterId"];
      url += "&filter=" + this.filter;
      url = encodeURI(url);
      window.open(url, "_blank");
    },
    handleSearch() {
      this.$notify({
        title: "Order",
        message: "Fetching data...",
        type: "success",
      });
      const data = {
        startDate: this.startDate,
        endDate: this.endDate,
        outfitterId: this.outfitterId,
        filter: this.filter,
      };
      this.$store.dispatch("order/get_orders", data).then((resp) => {
        if (!resp.orders || !resp.orders.length) {
          this.$notify({
            title: "Order",
            message: "No orders found for today",
            type: "warning",
          });
        }
      });
    },
    showDetail(id) {
      this.$router.push("/dashboard/order-detail/" + id);
    },
  },
  computed: {
    orders: function () {
      return this.$store.getters["order/getOrders"];
    },
    outfitterId: function () {
      return this.$store.getters["auth/outfitterId"];
    },
  },
  watch: {
    outfitterId: function () {
      this.handleSearch();
    },
  },
  mounted() {
    let today = new Date();
    this.startDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    this.endDate = this.startDate;
    if (this.outfitterId) {
      this.handleSearch();
    }
  },
};
</script>

<style scoped>
>>> table.vgt-table td {
  padding: 0.25em;
  font-size: 14px;
}
>>> .vgt-table th.sortable button {
  font-size: 14px;
}
</style>
